import "primeicons/primeicons.css";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../breadCrumbs/BreadCrumb";
export function PageHeader({
  routeid,
  headerText,
  hideBreadcrumbs = false,
  children,
}: {
  routeid?: string;
  headerText: any[];
  hideBreadcrumbs?: boolean;
  icon?: string;
  children?: React.ReactNode;
}) {
  const [shadow, setshadow] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () => setshadow(window.scrollY > 200));
    }
  }, []);
  return (
    <>
      {" "}
      <div id="page-header" className={`header ${shadow ? "shadow" : ""} page-stick-header text-black bg-grey`}>
        <div className="flex justify-between items-center main-header">
          {" "}
          <div>
            {" "}
            {headerText.map((headText, index) => (
              <div key={index} className="flex items-center">
                {headText.icon && <span className={headText.icon}></span>}
                <h2 key={index} className={" m-0 flex items-center " + headText.class}>
                  {" "}
                  {headText.value} {routeid ? <span> &nbsp; - {routeid}</span> : <span> </span>}
                </h2>
              </div>
            ))}{" "}
          </div>
          <div> {!hideBreadcrumbs && <BreadCrumb />}</div>
        </div>
        {children}
      </div>
    </>
  );
}
